<script lang="ts">
  import ObjectButtonInputGroup from "./ObjectButtonInputGroup.svelte";

  export let header: string;
  export let selectValue: (value: object) => void;
  export let selectedValue: object;
  export let values: Object[] = [];
  export let key: string;
  export let showSlot: boolean;

</script>

<div class="fizz-card fizz-bordered">
  <div class="fizz-surface-gray fizz-inset-square-16 fizz-stack-16 fizz-border-bottom">
    <h4 class="fizz-heading-4">{header}</h4>
  </div>
  <div class="fizz-inset-horizontal-16 fizz-stack-16">
    <ObjectButtonInputGroup {values} {selectValue} {selectedValue} {key} />
  </div>
  {#if showSlot}
    <div class="fizz-flex-row-8 fizz-inset-horizontal-16 fizz-stack-16">
      <slot />
    </div>
  {/if}
</div>
